import React from "react";
import "./Gridapp.css";
import smoothscroll from "smoothscroll-polyfill";
import Controller from "./controller/Controller";
import Curiculum from "./views/Curiculum";
import Gallery from "./views/Gallery";
import Hero from "./views/Hero";
import Intro from "./views/Intro";
import Mission from "./views/Mission";
import Sustainability from "./views/Sustainability";
import Nav from "./gridViews/Nav";
import AboutHero from "./gridViews/aboutus/AboutHero";
import AboutIntro from "./gridViews/aboutus/AboutIntro";
import AboutMission from "./gridViews/aboutus/AboutMission";
import AboutCuriculum from "./gridViews/aboutus/AboutCurriculum";
import AboutGallery from "./gridViews/aboutus/AboutGallery";
import Footer from "./gridViews/Footer";
import AboutOurHelp from "./gridViews/aboutus/AboutOurHelp";
import AboutSustainability from "./gridViews/aboutus/AboutSustainability";
import NavCurriculum from "./gridViews/NavCurriculum";

import { IoChevronUpOutline } from "react-icons/io5";
import { HiMenuAlt2 } from "react-icons/hi";
import { AiFillHome } from "react-icons/ai";
import AboutMainIntro from "./gridViews/aboutus/AboutMainIntro";

function App() {
  const [show, setShow] = React.useState(false);
  const [heightTo, setHeightTo] = React.useState();
  const [controlTop, setControlTop] = React.useState(false);
  const [imgChange, setImgChange] = React.useState(true);
  const [moveOpacity, setMoveOpacity] = React.useState(0);
  const [count, setCount] = React.useState(0);
  const [sectionCount, setSectionCount] = React.useState(6);
  const [sectionShow, setSectionShow] = React.useState(false);
  const [switchEL, setswitchEL] = React.useState(true);

  React.useEffect(() => {
    // kick off the polyfill!
    smoothscroll.polyfill();
    setTimeout(() => {
      // handleClientRect(".helpEl", 1, true, false);
      handleClientRect(".curriculum__display", 0.27, false, true);

      handleElAppearance("aboutus__intro-title", 0);
      handleElAppearance("about__intro_pillars", 0.3);
      handleElAppearance("about__mission_imgcontainer", 0.2);
      handleElAppearance("ourhelp_descriptioncontainer", 0.2);
      handleElAppearance("about__ourhelp_emptycontainer", 0.2);
      handleElAppearance("Sustainability_descriptioncontainer", 0.1);

      // handleClientRect(".galleryEl", 1, false, true);
    }, 1000);
  }, []);

  const appSections = [
    { section: "heroEl", el: <AboutHero /> },
    { section: "mainintroEl", el: <AboutMainIntro /> },
    { section: "introEl", el: <AboutIntro /> },
    { section: "missionEl", el: <AboutMission /> },
    { section: "helpEl", el: <AboutOurHelp /> },
    { section: "sustainableEl", el: <AboutSustainability /> },
    { section: "curriculum__display", el: <AboutCuriculum count={count} /> },
    { section: "galleryEl", el: <AboutGallery /> },
    { section: "footerEl", el: <Footer /> },
  ];

  //galleryEl

  const test = [];

  // Observer slow appearance
  const handleElAppearance = (target, thresh, val_1, val_2) => {
    const targetEl = document.getElementById(target);
    const controlEl = document.querySelector(".safe__area");
    const backgroundImgEl = document.getElementById("background__img");
    const observerOptions = {
      root: document.querySelector(".App"),
      rootMargin: "0px",
      threshold: thresh,
    };

    // function showMoveUp() {
    //   setTimeout(() => {
    //     setMoveOpacity(1);
    //   }, 1000);
    // }

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        console.log(entry);
        console.log(controlTop);

        if (target === "aboutus__intro-title" && entry.isIntersecting) {
          controlEl.style.backgroundColor = "white";
          backgroundImgEl.src = "./img/img-0.jpg";
        }
        if (target === "about__mission_imgcontainer" && entry.isIntersecting) {
          controlEl.style.backgroundColor = "transparent";
          backgroundImgEl.src = "./img/img-10.jpg";
        }
        if (entry.isIntersecting) {
          // console.log(entry.boundingClientRect.top);
          targetEl.classList.remove("slow__display");
          targetEl.classList.remove("slow__hori__display");
          // controlEl.style.backgroundColor = "white";
        } else {
          controlEl.style.backgroundColor = "transparent";
        }
      });
    };
    const observer = new IntersectionObserver(
      observerCallback,
      observerOptions
    );
    observer.observe(targetEl);
    setControlTop(true);
  };
  // Observer curriculum
  const handleClientRect = (target, thresh, val_1, val_2) => {
    const targetEl = document.querySelector(target);
    const controlEl = document.getElementById("tab__controller");
    const observerOptions = {
      root: document.querySelector(".App"),
      rootMargin: "0px",
      threshold: thresh,
    };

    // function showMoveUp() {
    //   setTimeout(() => {
    //     setMoveOpacity(1);
    //   }, 1000);
    // }

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        console.log(entry);
        console.log(controlTop);

        if (test.length === 0) {
          test.push(entry.boundingClientRect.top);
          setHeightTo(test[0]);
        }

        if (entry.isIntersecting) {
          // console.log(entry.boundingClientRect.top);
          setswitchEL(val_1);
          controlEl.classList.remove("hidden");
          // setCount(0);
        } else {
          // setS
          controlEl.classList.add("hidden");
          setswitchEL(val_2);
          // setCount(0);
          // setShowJump(false);
        }
      });
    };
    const observer = new IntersectionObserver(
      observerCallback,
      observerOptions
    );
    observer.observe(targetEl);
    setControlTop(true);
  };

  const sectionBelt = () => {
    return appSections.map((sections, i) => {
      console.log(sections);

      return (
        <div key={sections.section} className={sections.section}>
          {sections.el}
        </div>
      );
    });
  };
  // const sectionBeltSearch = () => {
  //   return appSections.map((sections, i) => {
  //     console.log(sections);
  //     if (i === sectionCount) {
  //       return (
  //         <div key={sections.section} className={sections.section}>
  //           {sections.el}
  //         </div>
  //       );
  //     }
  //   });
  // };

  return (
    <div className="App">
      <div id="tab__controller" className="tab__controller hidden">
        <div className="nav__menu">
          <HiMenuAlt2
            onClick={() => {
              setSectionShow(false);
              setswitchEL(true);
            }}
            size={20}
          />
        </div>
        <div className="view__up">{/* <IoChevronUpOutline size={35} /> */}</div>
        <div className="scroll__top">
          <AiFillHome
            onClick={() => {
              const homeTop = document.querySelector(".safe__area");

              homeTop.scrollTo({
                top: 0,
                behavior: "smooth",
              });
            }}
            size={30}
          />
        </div>
      </div>

      {switchEL ? (
        <Nav />
      ) : (
        <NavCurriculum heightTo={heightTo} count={count} setCount={setCount} />
      )}
      <div className="app__backgroundimg">
        <img id="background__img" src="/img/img-0.jpg" />
      </div>
      <div className="safe__area">
        <div className="aboutus__container">{sectionBelt()}</div>
      </div>
    </div>
  );
}

export default App;
